import { graphql } from "@opensea/graphql"
import { QuoteReceiptFragment } from "../../../../../components/QuoteReceipt/QuoteReceipt.fragment"

export const AcceptOfferReceiptFragment = graphql(
  `
    fragment AcceptOfferReceipt on Quote {
      ...QuoteReceipt
    }
  `,
  [QuoteReceiptFragment],
)
